<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>                                                 
<!--                    <h1>-->
<!--                        Manage Users-->
<!--                    </h1>-->

                    <b-row>
                        <b-col md="6">
                            <b-button variant="outline-primary mt-1 tb-button tb-button--blue font-h2 font-thin create-new" to="/admin/users/create">
                                Create New User
                            </b-button>
                        </b-col>

                        <b-col md="6">
                            <b-input-group class="mt-3 mt-md-1">
                                <b-form-input v-model="filter" placeholder="Type to search" class="tb-form-field tb-form-field--large" />
                                <b-input-group-append>
                                    <b-button :disabled="!filter" @click="filter = ''" class="tb-clear-button">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    
                    <b-table class="mt-3 tb-table"
                        stacked="md"
                        :filter="filter"
                        :items="users"
                        :fields="fields">

                        <template slot="actions" slot-scope="row">
                            <b-button class="btn-info mr-2  tb-table__button tb-table__button--gold" :to="{ name: 'edit-user', params: { id: row.item.id } }">
                                Edit
                            </b-button>

                            <b-button class="btn-danger tb-table__button tb-table__button--blue" @click="askDeleteItem(row.item)">
                                Delete
                            </b-button>
                        </template>
                    </b-table>

                    <b-modal 
                        v-model="show_delete_modal"
                        id="delete-modal"
                        title="Warning"
                        @ok="deleteItem()"
                        header-bg-variant="danger"
                        header-text-variant="light"
                        ok-title="Delete"
                        ok-variant="danger">
                        Are you sure you want to permanently delete this user account?
                    </b-modal>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import userRepository from "@/repository/users";

    export default {
        data() {
            return {
                fields: [
                    {
                        key: "name",
                        sortable: true
                    },
                    {
                        key: "email",
                        sortable: true
                    },
                    {
                        key: "role",
                        sortable: true
                    },
                    'actions'
                ],
                show_delete_modal: false,
                user_to_delete: null,
                filter: "",
                users:[],
                loaded:false
            }
        },

        mounted(){
            userRepository.getAll()
                .then( response => {
                    this.users = response.data;
                    this.loaded = true;
                });
        },

        methods: {
            askDeleteItem(item) {
                this.show_delete_modal = true;
                this.user_to_delete = item;
            },

            deleteItem() {
                userRepository.destroy(this.user_to_delete.id)
                    // eslint-disable-next-line no-unused-vars
                    .then(resp=>{
                        let id = this.users.findIndex(user => user.id == this.user_to_delete.id);

                        this.users.splice(id, 1);

                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'User Deleted',
                            text: 'User successfully deleted.'
                        });
                    })
            }
        }
    }
</script>

<style scoped>

</style>